import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, TextInput, IconButton } from '@blend-ed/blendx-ui';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './messages';

const MessageInput = ({ onSendMessage }) => {
    const [message, setMessage] = useState('');
    const intl = useIntl();

    const handleSendMessage = () => {
        if (message.trim()) {
            onSendMessage(message);
            setMessage('');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <div className="view-ticket__input">
            {/* <div className="view-ticket__attachment-button">
                <IconButton
                    variant="text"
                    icon={<i className="fas fa-paperclip"></i>}
                    aria-label="Attach file"
                />
            </div> */}
            <TextInput
                value={message}
                onChange={(e) => setMessage(e.value)}
                onKeyDown={handleKeyDown}
                placeholder={intl.formatMessage(messages.typeYourMessage)}
                className="view-ticket__message-input"
            />
            <Button
                variant="primary"
                onClick={handleSendMessage}
                disabled={!message.trim()}
            >
                {intl.formatMessage(messages.send)}
            </Button>
        </div>
    );
};

MessageInput.propTypes = {
    onSendMessage: PropTypes.func.isRequired
};

export default MessageInput; 